// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8792 ? "main" : chunkId) + "." + {"3408":"d2028a43d8094e649617","8792":"41caffdebe24077270e7"}[chunkId] + ".css";
};